module.exports = __webpack_public_path__ + "assets/img/pwdlogin.dc13e6f9.png";